<template>
  <div class="product-block links-swiper-container mb-5">
    <a class="reading-room-link" href="/articles/?from=single-model" title="Читальный зал">ЧЗ</a>
    <div class="links-swiper">
      <div ref="swiper" v-swiper:linksSwapper="swiperOptions" class="swiper links-cnt ">
        <div class="links-wrapper swiper-wrapper">
          <a
            v-for="article in articles"
            :key="article.id"
            :href="'/articles/'+ article.url + '?from=single-model'"
            target="_blank"
            class="swiper-slide"
            :class="{short: article.class}"
          >
            <span class="link-span" :title="article.title">{{article.title}}</span>
            <span class="link-date">{{article.date | correctDateRu}}</span>
          </a>
        </div>
      </div>
      <bim-button
        label=" "
        text-color="#4d4d4d"
        color="white"
        noshadow
        id="links-button-prev"
        class="swiper-button-prev add-spec-level p-0"
      />
      <bim-button
        label=" "
        text-color="#4d4d4d"
        color="white"
        noshadow
        id="links-button-next"
        class="swiper-button-next add-spec-level p-0"
      />
    </div>
  </div>
</template>

<script>
import { directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'LinksSwiper',
  directives: {
    swiper: directive,
  },
  data() {
    return {
      articles: [],
      swiperOptions: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        freeMode: true,
        navigation: {
          nextEl: '#links-button-next',
          prevEl: '#links-button-prev',
        },
      }
    }
  },
  mounted() {
    this.loadArticles(6)
    this.linksSwapper.on("reachEnd", this.loadArticles)
  },
  methods: {
    async loadArticles(limit=3) {
      const offset = this.articles.length || 0

      try {
        const articles = await this.$store.dispatch('getArticles', { limit, offset, params: 'all' })

        this.articles.push(...this.structuringApiArticles(articles))

        this.$nextTick(() => {
          const { swiper } = this.$refs.swiper

          if (swiper) {
            swiper.update()
          }
        })

      } catch (e) {
        console.log('loadArticles', e)
      }
    },
    structuringApiArticles(arr) {
      return arr.map(art => {
        const vers = art.lang_versions[1]

        // если длина заголовка больше заданной, сократить до указанной
        let _class = "";
        let title = vers.title
        if (title.length > 60) {
          _class = "short"
          title = title.substring(0, 40)
        }

        return {
          id: art.id,
          url: vers.url_certain_lang,
          date: vers.public_date,
          title: title,
          class: _class
        }
      })
    }
  },
  filters: {
    /**
     * Корректирует дату для ру региона
     * @param date
     * @return {string} - отформатированная строка в зависимости
     * сколько времени прошло с момента публикации
     * возвращает "Сегодня", "Вчера", либо дату
     * в формате "день.месяц" напр. "15.01"
     */
    correctDateRu(date) {
      const publishDate = new Date(date)
      const today = new Date()
      const diff = (today - publishDate) / 1000 / 60

      if (diff < 24) {
        return "Сегодня"
      }
      else if (diff < 48) {
        return "Вчера"
      }
      else {
        const addZero = num => parseInt(num) <= 9 ? "0" + num : num
        return `${addZero(publishDate.getDate())}.${addZero(publishDate.getMonth() + 1)}`
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .links-cnt {
    flex: 1;
    display: block;
    width: 100%;
    height: 22px;
  }

  .links-swiper-container {
    position: relative;
    z-index: 1;
  }

  .links-wrapper {
    position: absolute;
  }
</style>
